import { MenuCard } from '@runway/devkit';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

export const AMLComputeCluster: FC = () => {
  const navigate = useNavigate();

  return (
    <MenuCard
      title="Azure Machine Learning Compute Cluster"
      subtitle="Create a compute cluster in Azure Machine Learning"
      onButtonClick={() => navigate('/dataanalytics/aml-cc')}
      buttonText="Create"
    />
  );
};
